import {
  EKYC_FAILED_CONTACT_CODES,
  INVALID_DEMOGRAPHIC,
  Photo_Not_Matched
} from 'common/constants';
import { setError } from 'store/actions/auth';
import { ekycCheckingStatusV3, setEkycKey } from 'store/actions/disburse';

export const handleSuccessEkycVerificationV3 = (dispatch, auth, res, param) => {
  const statusCode = res?.data?.code;

  const errorMap = {
    1000: 'contact-cs',
    5003: Photo_Not_Matched,
    211153: Photo_Not_Matched,
    405: 'system',
    422: 'system'
  };

  if (EKYC_FAILED_CONTACT_CODES.includes(statusCode)) {
    dispatch(setError(INVALID_DEMOGRAPHIC));
    return;
  }

  if (errorMap[statusCode]) {
    dispatch(setError(errorMap[statusCode]));
    return;
  }

  dispatch(setEkycKey(res?.data?.data?.kycEventId));

  if (param?.reKycForVidaESignPurpose) {
    dispatch(
      ekycCheckingStatusV3(auth, {
        isReekyc: true,
        action: param.action
      })
    );
  } else {
    dispatch(ekycCheckingStatusV3(auth));
  }
};
